import { ReportTypeID } from '~/src/dash/apiV2/reporting/reportTypes';
import { ISimpleOption, TKey } from '~/src/dash/publicaUI';

export enum EReportPeriod {
  Unknown = 0,
  LastDay,
  Last3Days,
  Last7Days,
  Last15Days,
  CurrentMonth,
  LastMonth,
  CurrentYear,
  Last31Days,
  Last14Days,
  Last30Days,
}

export const getReportPeriodTKey = (period: EReportPeriod): TKey => {
  switch (period) {
    case EReportPeriod.LastDay:
      return 'LastDay';
    case EReportPeriod.Last3Days:
      return 'LastThreeDays';
    case EReportPeriod.Last7Days:
      return 'LastSevenDays';
    case EReportPeriod.Last15Days:
      return 'LastFifteenDays';
    case EReportPeriod.Last31Days:
      return 'LastThirtyOneDays';
    case EReportPeriod.CurrentMonth:
      return 'CurrentMonth';
    case EReportPeriod.LastMonth:
      return 'LastMonth';
    case EReportPeriod.CurrentYear:
      return 'CurrentYear';
    case EReportPeriod.Last14Days:
      return 'LastFourteenDays';
    case EReportPeriod.Last30Days:
      return 'LastThirtyDays';
    default:
      return 'LastDay';
  }
};

export const periods: Array<ISimpleOption> = [
  { key: 'period', value: String(EReportPeriod.LastDay), label: 'Last Day' },
  { key: 'period', value: String(EReportPeriod.Last3Days), label: 'Last 3 Days' },
  { key: 'period', value: String(EReportPeriod.Last7Days), label: 'Last 7 Days' },
  { key: 'period', value: String(EReportPeriod.Last15Days), label: 'Last 15 Days' },
  { key: 'period', value: String(EReportPeriod.Last31Days), label: 'Last 31 Days' },
  { key: 'period', value: String(EReportPeriod.CurrentMonth), label: 'Current Month' },
  { key: 'period', value: String(EReportPeriod.LastMonth), label: 'Last Month' },
  { key: 'period', value: String(EReportPeriod.CurrentYear), label: 'Current Year' },
];

export const iasPeriods: Array<ISimpleOption> = [
  { key: 'period', value: String(EReportPeriod.LastDay), label: 'Last Day' },
  { key: 'period', value: String(EReportPeriod.Last7Days), label: 'Last 7 Days' },
  { key: 'period', value: String(EReportPeriod.Last14Days), label: 'Last 14 Days' },
  { key: 'period', value: String(EReportPeriod.Last30Days), label: 'Last 30 Days' },
  { key: 'period', value: String(EReportPeriod.CurrentMonth), label: 'Current Month' },
  { key: 'period', value: String(EReportPeriod.LastMonth), label: 'Last Month' },
];

export enum EReportFrequency {
  Unknown = 0,
  FrequencyDaily,
  FrequencyWeekly,
  FrequencyMonthly,
}

export const getReportFrequencyTKey = (frequency: EReportFrequency): TKey => {
  switch (frequency) {
    case EReportFrequency.FrequencyDaily:
      return 'FrequencyDaily';
    case EReportFrequency.FrequencyWeekly:
      return 'FrequencyWeekly';
    case EReportFrequency.FrequencyMonthly:
      return 'FrequencyMonthly';
    default:
      return 'FrequencyDaily';
  }
};

export const frequencies: Array<ISimpleOption> = [
  { key: 'frequency', value: String(EReportFrequency.FrequencyDaily), label: 'Daily' },
  { key: 'frequency', value: String(EReportFrequency.FrequencyWeekly), label: 'Weekly' },
  { key: 'frequency', value: String(EReportFrequency.FrequencyMonthly), label: 'Monthly' },
];

export enum EReportDelivery {
  Unknown = 0,
  Email,
  AWSS3,
}

export const deliveries: Array<ISimpleOption> = [
  { key: 'delivery', value: String(EReportDelivery.Email), label: 'Email' },
  { key: 'delivery', value: String(EReportDelivery.AWSS3), label: 'AWS S3' },
];

export const getReportDeliveryTKey = (delivery: EReportDelivery): TKey => {
  switch (delivery) {
    case EReportDelivery.Email:
      return 'Email';
    case EReportDelivery.AWSS3:
      return 'AWSS3';
    default:
      return 'Email';
  }
};

export enum EReportPriority {
  Unknown = 0,
  Scheduled = 1,
  Email = 5,
  PublicAPI = 9,
}

export const monthlyScheduledDays: Array<ISimpleOption> = [...Array(31).keys()].map((_, idx) => {
  const value = String(idx + 1);
  return { key: 'scheduledDays', value, label: value };
});

export const weeklyScheduledDays = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
].map((day, idx) => {
  return { key: 'scheduledDays', value: String(idx + 1), label: day };
});

export enum EReportTypeCategory {
  QuickReports = 'Quick Reports',
  InvestigationReports = 'Investigation',
}

export const getReportTypeCategory = (category: number): EReportTypeCategory => {
  return category === 1
    ? EReportTypeCategory.QuickReports
    : EReportTypeCategory.InvestigationReports;
};

export const QUICK_REPORTS = [
  ReportTypeID.AuctionQuickReport,
  ReportTypeID.CampaignQuickReport,
  ReportTypeID.BidderQuickReport,
  ReportTypeID.AdomainQuickReport,
  ReportTypeID.ContentQuickReport,
  ReportTypeID.AppBundleQuickReport,
];
